import logo from "../../assets/images/logo.svg";
import { Link, NavLink, useLocation } from "react-router-dom";
import useAuth from "../../lib/hooks/useAuth";
import navtwo from "../../assets/images/navtwo.svg";
import navthree from "../../assets/images/navthree.svg";
import logoace from "../../assets/images/logoace.svg";
import navfour from "../../assets/images/navfour.svg";
import navfive from "../../assets/images/navfive.svg";
import navsix from "../../assets/images/navsix.svg";
import navseven from "../../assets/images/navseven.svg";
import naveight from "../../assets/images/naveight.svg";
import navten from "../../assets/images/navten.svg";
import navele from "../../assets/images/navele.svg";
import back from "../../assets/images/back.svg";
import ham from "../../assets/images/ham.svg";
import mthree from "../../assets/images/mthree.png";
import mfour from "../../assets/images/mfour.png";
import navone from "../../assets/images/navone.svg";
import styles from "./style.module.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDataFailure,
  fetchDataStart,
  fetchDataSuccess,
} from "../../redux/slices/userSlice";
import { getUserData } from "../../redux/api";
import { STRINGS } from "../../constants/strings";

const NavBar = () => {
  const { isAuthenticated } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [loader, setLoader] = useState<boolean>(true);
  const { data }: any = useSelector((state: any) => state.getUserData);
  const dispatch = useDispatch();

  useEffect(() => {
    const userData = async () => {
      dispatch(fetchDataStart());
      try {
        const userData = await getUserData();
        dispatch(fetchDataSuccess(userData?.data));
        setLoader(false);
      } catch (error: any) {
        dispatch(fetchDataFailure(error.message));
      }
    };
    if (isAuthenticated) userData();
  }, [isAuthenticated]);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 991);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();
  const [toggle, setToggle] = useState(false);

  const isActiveRoute = (route: string) => {
    return location.pathname === route;
  };

  return (
    <div className={styles.menuHead}>
      <div className="container">
        <nav className="navbar navbar-expand-lg pt-2">
          <div className="container-fluid p-0">
             <Link className={`navbar-brand`} to="/"> 
              <i className="pe-3 border-end broder-light border-2">
                <img width="120" height="36" src={logo} alt="Commbitz logo" /></i>
              <i>
                <img width="120" height="46" src={logoace} alt="Commbitz logo" /></i>
              </Link>
            {/* <Link className="navbar-brand" to="/">
              <img width="350" height="90" src={logo} alt="Commbitz logo" />
            </Link> */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={!toggle ? () => setToggle(true) : () => setToggle(false)}
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                {/* <i className="fas fa-bars"></i> */}
                {/* <img src={ham} alt="" /> */}
              </span>
            </button>
            {isMobile ? (
              <div className="mobUsername">
                <h4>
                  {STRINGS.WELCOME_GUEST}{" "}
                  <b> {isAuthenticated ? data?.fullName : "Guest"},</b>
                </h4>
                <h5> {STRINGS.WHERE_ARE_YOU_TRAVELING}</h5>
              </div>
            ) : (
              false
            )}

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
              style={toggle ? { display: "block" } : { display: "none" }}
            >
              <ul className={styles.navbar}>
                <li className={isActiveRoute("/") ? styles.active : ""}>
                  <NavLink className="nav-Link" to="/">
                    {STRINGS.HOME}
                  </NavLink>
                </li>
                <li className={isActiveRoute("/about") ? styles.active : ""}>
                  <NavLink className="nav-Link" to="/about">
                    {STRINGS.ABOUT_US}
                  </NavLink>
                </li>
                <li
                  className={
                    isActiveRoute(isAuthenticated ? "/profile" : "/login")
                      ? styles.active
                      : ""
                  }
                >
                  {/* <NavLink className={`nav-Link`} to="/esim-list">
                  {STRINGS.ESIM}
                  </NavLink> */}
                  {/* <div className={styles.loginBtn}> */}
                  {isAuthenticated ? (
                    <Link to="/profile"> {STRINGS.PROFILE}</Link>
                  ) : (
                    <Link to="/login"> {STRINGS.SIGNUP_LOGIN}</Link>
                  )}
                  {/* </div> */}
                </li>
                {/* <li
                  className={
                    isActiveRoute("/blog") || isActiveRoute("/blogdetail")
                      ? styles.active
                      : ""
                  }
                >
                  <a className="nav-Link" href="https://commbitz.com/esim/">
                    {STRINGS.BLOGS}
                  </a>
                </li> */}
                <li className={isActiveRoute("/contact") ? styles.active : ""}>
                  <NavLink className="nav-Link" to="/contact">
                    {STRINGS.CONTACT_US}
                  </NavLink>
                </li>
              </ul>
              {isMobile ? (
                <>
                  <div
                    className="newmobileSidebar"
                    onClick={
                      !toggle ? () => setToggle(true) : () => setToggle(false)
                    }
                  >
                    <div className="navback">
                      <span>
                        <img src={back} alt="" />
                      </span>
                      <h4> {STRINGS.PROFILE}</h4>
                    </div>
                    <div className="topSideHead">
                      <div className="lefttopSideHead">
                        <span>
                          {/* <img src={data?.avatar?.data?.avatar:userImg} alt={data?.fullName} /> */}
                        </span>
                        <div>
                          <h5>
                            {" "}
                            {STRINGS.WELCOME_GUEST}{" "}
                            {isAuthenticated ? data?.fullName : STRINGS.GUEST},
                          </h5>
                          <h6>
                            {isAuthenticated
                              ? data?.email
                              : STRINGS.WHERE_ARE_YOU_TRAVELING}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <ul>
                      <li>
                        <NavLink className="nav-Link" to="/">
                          <span>
                            <img src={navtwo} alt="" />
                          </span>
                          {STRINGS.HOME}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className="nav-Link" to="/about">
                          <span>
                            <img src={naveight} alt="" />
                          </span>
                          {STRINGS.ABOUT_US}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={`nav-Link`} to="/esim-list">
                          <span>
                            <img src={navthree} alt="" />
                          </span>
                          {STRINGS.ESIM}
                        </NavLink>
                      </li>
                      {/* <li>
                        <a href="https://commbitz.com/esim/">
                          <span>
                            <img src={navfour} alt="" />
                          </span>{" "}
                          {STRINGS.BLOGS}
                        </a>
                      </li> */}
                      <li>
                        <NavLink className="nav-Link" to="/faq">
                          <span>
                            <img src={navten} alt="" />
                          </span>
                          {STRINGS.FAQS}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className="nav-Link" to="/troubleshoot">
                          <span>
                            <img src={navfive} alt="" />
                          </span>
                          {STRINGS.TROUBLESHOOTING}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className="nav-Link" to="/features">
                          <span>
                            <img src={navele} alt="" />
                          </span>
                          {STRINGS.FEATURES}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className="nav-Link" to="/contact">
                          <span>
                            <img src={naveight} alt="" />
                          </span>
                          {STRINGS.CONTACT_US}
                        </NavLink>
                      </li>

                      {isAuthenticated ? (
                        <>
                          <li>
                            <Link to="/profile">
                              <img src={navsix} alt="" />
                              {STRINGS.PROFILE}
                            </Link>
                          </li>
                          <li>
                            <Link to="/purchase">
                              <img src={navone} alt="" />

                              {STRINGS.MY_PURCHASED_ESIM}
                            </Link>
                          </li>
                          <li>
                            <Link to="/order-histories">
                              <span>
                                <img src={navele} alt="" />
                              </span>
                              {STRINGS.ORDER_HISTORY}
                            </Link>
                          </li>
                          {/* <li>
                            <Link to="/notifications">
                              <span>
                                <img src={navseven} alt="" />
                              </span>
                              Notifications
                            </Link>
                          </li> */}
                          <li>
                            <NavLink to="/logout">
                              <span>
                                <img src={navseven} alt="" />
                              </span>
                              {STRINGS.LOGOUT}
                            </NavLink>
                          </li>
                        </>
                      ) : (
                        <li>
                          <Link to="/login"> {STRINGS.SIGNUP_LOGIN}</Link>
                        </li>
                      )}

                      {/* <li><a href="#"><span><img src={naveight} alt="" /></span> Terms &Condition</a></li>

                      <li><a href="#"><span><img src={naveight} alt="" /></span> Privacy Policy</a></li>
                      <li><a href="#"><span><img src={navnine} alt="" /></span> Contact Us</a></li>  */}
                    </ul>
                  </div>
                </>
              ) : (
                false
              )}
            </div>
            {/* <div className={styles.loginBtn}>
              {isAuthenticated ? (
                <Link to="/profile">  {STRINGS.PROFILE}</Link>
              ) : (
                <Link to="/login">  {STRINGS.SIGNUP_LOGIN}</Link>
              )}
            </div> */}
            <div className={styles.loginBtn}>
              <NavLink className={`nav-Link`} to="/esim-list">
                {STRINGS.ESIM}
              </NavLink>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default NavBar;
